<template>
    <div class="container p-0">
     <div class="surface-card p-4 shadow-2 border-round w-full lg:w-auto sm:w-auto mb-4 rounded-corners">
         <div class="text-center mb-5">
             <img src="@/assets/logo.png" alt="Image" height="80" class="mb-4 mt-3 logo-bg" />
             <!-- <div style="margin-top: 140px;"></div> -->
            <div class="text-900 text-2xl font-medium mb-3 text-color">شركاء للمكتبات الشخصية</div>
                 </div>
   
         <Divider class="mb-6"/>
   
         <div>
             <label for="email1" class="block text-900 font-medium mb-2 text-color text-center">البريد الإلكتروني</label>
             <IconField iconPosition="right">
                   <InputIcon class="pi pi-envelope mx-2"> </InputIcon>
                   <InputText id="email1" type="text" v-model="authStore.user.username" class="w-full mb-3"  @keyup.enter="login" />
               </IconField>
   
             <label for="password1" class="block text-900 font-medium mb-2 text-color text-center">كلمة السر</label>
             <IconField iconPosition="right">
                   <InputIcon class="pi pi-lock mx-2"> </InputIcon>
                   <InputText type="password" v-model="authStore.user.password" :feedback="false" class="w-full mb-3" @keyup.enter="login"/>
               </IconField>
   
             <Button label="دخول" icon="pi pi-sign-in" class="w-full my-1" @click="login" dir="rtl"></Button>
             <Button label="نسيت كلمة السر" icon="pi pi-question" class="w-full my-1" @click="showChangePasswordDialog" dir="rtl"></Button>
             <Button label="طلب انضمام" icon="pi pi-pencil" class="w-full mt-1 mb-3" @click="showJoinRequestDialog" dir="rtl"></Button>
         </div>
     </div>
   </div>
   
   
   </template>
   
   <script setup>
   import { onErrorCaptured, onMounted } from "vue"
   import { handleError } from '@/helpers/ErrorHandler'
   import { useToast } from "primevue/usetoast"
   import { useI18n } from 'vue-i18n'
   import { useAuthStore } from '@/stores/auth'
   import { useDialog } from 'primevue/usedialog'
   import ServerError from "@/model/ServerError"
   import PasswordChanger from '@/components/PasswordChanger.vue'
   import JoinRequest from "@/components/JoinRequest.vue"
   import { useSocketStore } from '@/stores/socket'
   
   import IconField from 'primevue/iconfield';
   import InputIcon from 'primevue/inputicon';
   import Divider from 'primevue/divider';
   
   const authStore = useAuthStore()
   const toast = useToast()
   const i18n = useI18n()
   const socketStore = useSocketStore()
   
   const dialog = useDialog()
   
   onMounted(() => {
       if (socketStore.connectionRetriesLeft === 0) {
           toast.add({ severity: 'error', summary: i18n.t('SERVER_SUDDEN_DEATH'), detail: '', life: 3000 })        
       }
   })
   
   onErrorCaptured((err, instance, info) => {
       return handleError(authStore, toast, i18n, err, instance, info)
   })
   
   const login = async () => {
       try {
           await authStore.login()
       } catch (error) {
           if (error instanceof ServerError && error.status === 401) {
               toast.add({ severity: 'error', summary: error.summary, detail: error.detail, life: 3000 })
           } else {
               throw error
           }
       }
   }
   
   const showChangePasswordDialog = () => {
       dialog.open(PasswordChanger, {
           props: {
               header: i18n.t('CHANGE_PASSWORD'),
               style: {
                   width: '20em',
               },
              /*  breakpoints: {
                   '960px': '75vw',
                   '640px': '90vw'
               }, */
               modal: true,
           },
           data: {
               withoutToken: true,
           },
           emits: {
               onPasswordChanged: (m) => {
                   toast.add({ severity: 'info', summary: m, detail: '', life: 3000 })
               },
               onError: (e) => {
                   handleError(authStore, toast, i18n, e)
               },
               onValidationError: (e) => {
                   toast.add({ severity: 'error', summary: e, detail: '', life: 3000 })
               }
           }
       })
   }
   
   const showJoinRequestDialog = () => {
       dialog.open(JoinRequest, {
           emits: {
               onError: (e) => {
                   if (e instanceof ServerError) {
                       toast.add({ severity: 'error', summary: e.detail, detail: '', life: 3000 })
                   } else {
                       handleError(authStore, toast, i18n, e)
                   }
               },
               onRequestSent: (m) => {
                   toast.add({ severity: 'info', summary: m, detail: '', life: 3000 })
               },
               onValidationError: (e) => {
                   toast.add({ severity: 'error', summary: e, detail: '', life: 3000 })
               }
           },
           props: {
               header: i18n.t('JOIN_REQUEST'),
               style: {
                   width: '25em',
               },
               breakpoints: {
                   '960px': '75vw',
                   '640px': '90vw'
               },
               modal: true
           }
       })
   }
   
   </script>
   
   <style scoped>
   
   .p-inputtext {
       text-align: center;
   }
   
   .container {
         display: flex;
         justify-content: center;
         align-items: center;
         height: 100dvh;
     }
   
   :deep(.p-password-input) {
       text-align: center;
   }
   
   div.login-buttons>button {
       margin: 0.2em;
   }
   
   .text-color {
     color: var(--blue-500) !important;
   
   }
   
   .rounded-corners {
       border-radius: 24px !important;
   }
   
   .pi {
       line-height: 0;
   }
   
   .logo-bg {
       background-color: var(--surface-logo);
       border-radius: 50%;
     }
   </style>